@if (auth.authenticated && trainingGuideURLs()?.length === 1) {
  <button
    class="training-guide-button"
    matButton="elevated"
    tooltip-position="below"
    matTooltipShowDelay="500"
    [disabled]="loading"
    [matTooltip]="'igo.integration.aboutTool.trainingGuideTooltip' | translate"
    (click)="openGuide()"
  >
    {{ 'igo.integration.aboutTool.trainingGuide' | translate }}
    <mat-icon>description</mat-icon>
  </button>
}

@if (auth.authenticated && (trainingGuideURLs()?.length ?? 0) > 1) {
  <button
    class="training-guide-button"
    matButton="elevated"
    tooltip-position="below"
    matTooltipShowDelay="500"
    [disabled]="loading"
    [matTooltip]="'igo.integration.aboutTool.trainingGuideTooltip' | translate"
    [matMenuTriggerFor]="menu"
  >
    {{ 'igo.integration.aboutTool.trainingGuide' | translate }}
    <mat-icon>description</mat-icon>
  </button>
}

<mat-menu #menu="matMenu">
  @for (guide of trainingGuideURLs(); track guide) {
    <button mat-menu-item (click)="openGuide(guide)">
      {{ formatFileName(guide) }}
    </button>
  }
</mat-menu>

@if (headerHtml !== '') {
  <igo-custom-html [html]="headerHtml | translate" />
}

<igo-custom-html [html]="html | translate: { version: effectiveVersion }" />
